export class Abbonamento {
  nome: string = '';
  prezzo: number = 0;
  revCoperto: number = 0;
  coperto: number = 0;
  coperto600: number = 0;
  coperto1000: number = 0;
  coperto1500: number = 0;
}
